module.exports = __webpack_public_path__ + "img/Integration_service_pic.22963bcd.jpg";